<template>
  <b-col sm="12" :lg="size" :offset="offset">
    <YearModal
        :modalID="chartType"
        :fetchData="fetchData"
        :year="year"
        @date-picker-modal-emit="onYearPickerModalEmit"
      ></YearModal>
    <b-card class="backClass">
      <div
        slot="header"
        style="display:flex; justify-content: space-between; align-items: center;"
      >
        <HeaderTitle :title="title">
          <small style="font-weight:600; color:#20a8d8">
            {{ chartType == "repair" ? year : "(YTD)" }}
          </small></HeaderTitle
        >
        <HeaderControl
          :showFullscreenIcon="true"
          :showDownloadPdfIcon="true"
          :showDateIcon="chartType == 'repair' ? true : false"
          @emit-fullscreen="toggleFullScreen"
          @emit-date="modalDateEvent(chartType)"
          @emit-pdf-download="downloadPDF"
        ></HeaderControl>
      </div>
      <div
        style="width: 100%; display: flex; justify-content: flex-end;"
        v-if="withFinancial"
      >
        <h5>Quantity</h5>
        <c-switch
          class="mx-1"
          color="primary"
          v-model="valueQuantity"
          value="true"
          uncheckedValue="false"
          variant="pill"
        />
        <h5>Financials</h5>
      </div>
      <div class="chart-wrapper">
        <div class="centered_container">
          <p>{{ message }}</p>
        </div>
        <LoadingCard
          class="centered_container"
          v-if="loadingData"
        ></LoadingCard>
        <highcharts
          ref="backRef"
          v-if="!loadingData && noProductsFlag"
          :options="chartOptions"
          class="chart"
          :constructor-type="'chart'"
          @click="handleChartClick"
        />
      </div>
    </b-card>
  </b-col>
</template>

<script>
import { Chart } from "highcharts-vue";
import Highcharts from "highcharts";
import exporting from "highcharts/modules/exporting";
import { chartFunctionsMixin } from "./addons/chartFunctionsMixin.js";
import { chartOptionsStackedMixin } from "./addons/chartOptionsStackedMixin.js";
import Datepicker from "vuejs-datepicker";
import YearModal from "../shared/YearModal.vue";
import { Switch as cSwitch } from "@coreui/vue";
import LoadingCard from "../shared/LoadingCard.vue";
import HeaderTitle from "../shared/HeaderTitle.vue";
import HeaderControl from "../shared/HeaderControl.vue";
exporting(Highcharts);

export default {
  mixins: [chartFunctionsMixin, chartOptionsStackedMixin],
  components: {
    highcharts: Chart,
    Highcharts,
    Datepicker,
    YearModal,
    cSwitch,
    LoadingCard,
    HeaderTitle,
    HeaderControl
  },
  data: function() {
    return {
      message: "",
      year: this.year ? this.year : new Date().getFullYear().toString(),
      noProductsFlag: true,
    };
  },
  props: [
    "size",
    "offset",
    "title",
    "isCity",
    "withDate",
    "withFinancial",
    "chartType",
    "city"
  ],
  methods: {
    handleChartClick(event) {
      if (this.chartType == "repair") {
        this.$router.push(
          "/base/Tables/?type=" +
          this.chartType +
          "&year=" +
          this.year +
          "&month=" +
          (event.point.index + 1)
        );
      }
      if (this.chartType == "historical") {
        this.$router.push(
          "/base/Tables/?type=historical" +
          "&year=" + event.srcElement.point.category
        );
      }
    },
    fetchData() {
      this.loadingData = true;
      this.message = "";
      let finType = "Fin";
      if (!this.valueQuantity || this.valueQuantity == "false") {
        finType = "Qty";
      }

      let link = null;
      let params = {};
      if (this.chartType == "repair") {
        params = {
          year: this.year,
          type: finType,
          client: this.city
        };
        link = `${process.env.VUE_APP_TRACKER_BASE}/api/sercomm/charts/repair.php`;
      } else if (this.chartType == "historical") {
        params = {
          date_from: "2021-01-01",
          date_to: this.dateTo,
          type: finType,
          client: this.city
        };

        if (this.city) {
          link = `${process.env.VUE_APP_TRACKER_BASE}/api/sercomm/charts/historicalByProdGroupCity.php`;
        } else {
          link = `${process.env.VUE_APP_TRACKER_BASE}/api/sercomm/charts/historicalByProdGroup.php`;
        }
      }

      this.$http.get(link, { params }).then(
        res => {
          if (res.data.message) {
            this.message = res.data.message;
            this.loadingData = false;
            this.noProductsFlag = false;
            return;
          } else {
            this.noProductsFlag = true;
            let myArray = res.data;
            let xAxis = [];
            var datum = [];

            var fiber = {
              name: "Total",
              data: [],
              color: "rgb(124, 181, 236)"
            };

            for (var type in myArray) {
              datum.push([type, myArray[type]]);
            }

            if (this.chartType == "repair") {
              datum.forEach(obj => {
                var last2 = obj[0].slice(-2);
                if (last2 == "01" || last2 == "1") {
                  xAxis.push("January");
                }
                if (last2 == "02" || last2 == "2") {
                  xAxis.push("February");
                }
                if (last2 == "03" || last2 == "3") {
                  xAxis.push("March");
                }
                if (last2 == "04" || last2 == "4") {
                  xAxis.push("April");
                }
                if (last2 == "05" || last2 == "5") {
                  xAxis.push("May");
                }
                if (last2 == "06" || last2 == "6") {
                  xAxis.push("June");
                }
                if (last2 == "07" || last2 == "7") {
                  xAxis.push("July");
                }
                if (last2 == "08" || last2 == "8") {
                  xAxis.push("August");
                }
                if (last2 == "09" || last2 == "9") {
                  xAxis.push("September");
                }
                if (last2 == "10") {
                  xAxis.push("October");
                }
                if (last2 == "11") {
                  xAxis.push("November");
                }
                if (last2 == "12") {
                  xAxis.push("December");
                }

                fiber.data.push(obj[1].Total);
              });
            } else {
              datum.forEach(obj => {
                xAxis.push(obj[0]);
                fiber.data.push(obj[1].Total);
              });
            }

            this.chartOptions.xAxis.categories = xAxis;
            this.chartOptions.series[0] = fiber;
            this.chartOptions.series[0].color = "rgb(144, 237, 125)";

            if (finType == "Fin") {
              this.chartOptions.tooltip.formatter = function() {
                return (
                  "<b>" +
                  this.x +
                  "</b><br>" +
                  this.series.name +
                  ": $" +
                  this.y
                    .toFixed(2)
                    .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")
                );
              };

              this.chartOptions.plotOptions.column.dataLabels.formatter = function() {
                return (
                  "$" +
                  this.y
                    .toFixed(2)
                    .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")
                );
              };

              this.chartOptions.yAxis.stackLabels.formatter = function() {
                return (
                  "Total: " +
                  "$" +
                  this.total
                    .toFixed(2)
                    .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")
                );
              };
            } else {
              this.chartOptions.tooltip.formatter = function() {
                return (
                  "<b>" +
                  this.x +
                  "</b><br>" +
                  this.series.name +
                  ": " +
                  this.y +
                  " units"
                );
              };

              this.chartOptions.plotOptions.column.dataLabels.formatter = function() {
                return this.y;
              };

              this.chartOptions.yAxis.stackLabels.formatter = function() {
                return "Total: " + this.total;
              };
            }

            this.loadingData = false;
            setTimeout(() => {
              this.changeHeight();
            });
            this.message = "";
          }
        },
        err => {
          this.loadingData = false;
          console.log(err);
        }
      );
    },
    onYearPickerModalEmit(emittedValue) {
      this.year = emittedValue;
    },
  },
  mounted() {
    this.fetchData();
  }
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
.highcharts-exporting-group {
  display: none !important;
}
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
.vdp-datepicker__calendar {
  position: absolute !important;
  z-index: 100;
  background: #3a4149 !important;
  width: 300px;
  border: 1px solid #ccc;
}
.form-control:disabled,
.form-control[readonly] {
  background-color: #515b65 !important;
  opacity: 1 !important;
}
.centered_container {
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>
